"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var react_router_dom_1 = require("react-router-dom");
var PrimaryControls_styles_1 = __importDefault(require("./PrimaryControls.styles"));
var AGCurrentRefinements_1 = __importDefault(require("../../molecules/AGCurrentRefinements/AGCurrentRefinements"));
var Button_1 = __importDefault(require("../../atoms/Button/Button"));
var ExportBtn_1 = __importDefault(require("../../molecules/ExportBtn/ExportBtn"));
var ColumnSelection_1 = __importDefault(require("../../organisms/ColumnSelection/ColumnSelection"));
var AGSearchBox_1 = __importDefault(require("../../molecules/AGSearchBox/AGSearchBox"));
var PrimaryControls = function () { return (react_1.default.createElement(PrimaryControls_styles_1.default, null,
    react_1.default.createElement("h1", { className: "title" }, "Sportaanbod in Rotterdam"),
    react_1.default.createElement(react_instantsearch_dom_1.Stats, { translations: {
            stats: function (nbHits) {
                return nbHits + " resultaten";
            },
        } }),
    react_1.default.createElement("div", { className: "controls" },
        react_1.default.createElement(ColumnSelection_1.default, null),
        react_1.default.createElement(ExportBtn_1.default, null),
        react_1.default.createElement(AGSearchBox_1.default, null),
        react_1.default.createElement(react_router_dom_1.Link, { to: "/add" },
            react_1.default.createElement(Button_1.default, { className: "secondary" },
                react_1.default.createElement("span", null,
                    "Aanbod toevoegen \u00A0",
                    react_1.default.createElement("svg", { className: "icon icon-plus", "aria-hidden": "true" },
                        react_1.default.createElement("use", { xmlnsXlink: 'http://www.w3.org/1999/xlink', xlinkHref: '/dist/svg/sprite.min.svg#plus' })))))),
    react_1.default.createElement(AGCurrentRefinements_1.default, null))); };
exports.default = PrimaryControls;
